import * as h2Api from '../h2Api'
import * as louisianaIGPActions from '../actions/louisianaIGP'

const initialState = {
  igp: null
}

export default (state = initialState, action) => {
  switch (action.type) {
    case louisianaIGPActions.FETCH_IGP_DATA:
      if (action.restCall.status === h2Api.REST_CALL_STATUS.RECEIVED) {
        return {
          ...state,
          igp: action.restCall.result.igp,
          isReady: true
        }
      }

      return state

    default:
      return state
  }
}
